import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------Setting---------------------------
export const UpdateSettingApi = async (data) => {
  const endPoint = `/setting/update_setting`;
  return await axios.post(endPoint, data, setJwtToken());
};
export const getSettingApi = async (data) => {
  const endPoint =
    `/setting` + `?` + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
